import {
    mdiArrowRightBoldCircle,
    mdiBank,
    mdiBankOutline,
    mdiCancel,
    mdiCheckCircle,
    mdiClockOutline,
    mdiFlag,
    mdiGavel,
    mdiAlertOutline,
    mdiSend,
    mdiUmbrellaBeachOutline,
} from '@mdi/js';
import _ from 'lodash';
import React from 'react';
import * as S from './transmission-status-badge.styles';
import { TransmissionStatusType } from './util';

export type BadgeSize = 'small' | 'large';

export interface ITransmissionStatusBadgeProps {
    className?: string;
    size: BadgeSize;
    status?: keyof typeof TransmissionStatusType;
    messageCode?: string;
}

export class TransmissionStatusBadge extends React.Component<ITransmissionStatusBadgeProps> {
    public render(): React.ReactElement {
        const { size, status, className, messageCode } = this.props;
        const label = this.getLabel(status, messageCode);

        return (
            <S.Badge size={size} claimStatus={status} className={className}>
                {size === 'large' && this.renderBadgeIcon()}
                <S.BadgeLabel>{label}</S.BadgeLabel>
            </S.Badge>
        );
    }
    private readonly renderBadgeIcon = (): React.ReactElement | string => {
        if (this.props.status) {
            switch (this.props.status) {
                case TransmissionStatusType.SUBMITTED:
                    return <S.BadgeIcon path={mdiSend} />;
                case TransmissionStatusType.ACKNOWLEDGED:
                    return <S.BadgeIcon path={this.getAcknowledgedIconPath()} />;
                case TransmissionStatusType.ADJUDICATED:
                    return <S.BadgeIcon path={mdiGavel} />;
                case TransmissionStatusType.COMPLETED:
                    return <S.BadgeIcon path={mdiCheckCircle} />;
                case TransmissionStatusType.REJECTED:
                    return <S.BadgeIcon path={mdiFlag} />;
                case TransmissionStatusType.DENIED:
                    return <S.BadgeIcon path={mdiCancel} />;
                case TransmissionStatusType.FORWARDED:
                    return <S.BadgeIcon path={mdiArrowRightBoldCircle} />;
                case TransmissionStatusType.WARNING:
                    return <S.BadgeIcon path={mdiAlertOutline} />;
                default:
                    return <S.BadgeIcon path={mdiClockOutline} />;
            }
        }

        return <S.BadgeIcon path={mdiClockOutline} />;
    };

    private readonly getLabel = (
        status?: keyof typeof TransmissionStatusType,
        messageCode?: string,
    ): string => {
        if (!status) {
            return 'Preparing';
        }

        if (status === TransmissionStatusType.ACKNOWLEDGED) {
            const normalizedMessageCode = (messageCode || '').trim().toUpperCase();

            if (normalizedMessageCode === 'ACK') {
                return 'Clearinghouse Acknowledged';
            }

            if (/^A[12]\d{2}(?:-.+)?$/i.test(normalizedMessageCode)) {
                return 'Payer Acknowledged';
            }
        }

        return _.startCase(TransmissionStatusType[status].toLowerCase());
    };

    private readonly getAcknowledgedIconPath = (): string => {
        const normalizedMessageCode = (this.props.messageCode || '').trim().toUpperCase();

        if (normalizedMessageCode === 'ACK') {
            return mdiBankOutline;
        }

        if (/^A[12]\d{2}(?:-.+)?$/i.test(normalizedMessageCode)) {
            return mdiUmbrellaBeachOutline;
        }

        return mdiBank;
    };
}
